import * as XLSX from 'xlsx';

import {
  ACCEPTABLE_IMAGE_TYPE,
  SHEET_FILE_TYPE,
  TEXTURE_FILTER_LABEL,
  TEXTURE_UPLOADS_FROM_TYPES,
} from '../../constants/constants';
import {
  BulkTextureUploadProgress,
  TextureUploadProgress,
} from '../admin/curator/stylesSection/TexturesTab/TextureUploadProgress';
import {
  DOWNLOAD_XLSX_TEXTURE,
  TEXTURE_BULK_UPDATE,
  TEXTURE_BULK_UPLOAD,
  apiBulkDeleteTextures,
  apiBulkEditTextures,
  apiGetImagePresignedData,
  apiGetImagePresignedDataBySkuID,
  apiGetTextures,
  apiPostImageOnPresignedData,
  apiTrashForeverTextureDelete,
  callGetFilterOptionsId,
} from '../../helpers/api';
import { Loader, ModalButtonArea } from '../../common';
/* eslint-disable */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  bulkTextureUploadActions,
  selectIsBulkTextureModalExpand,
  selectIsBulkTextureModalOpen,
} from '../../redux/slicers/bulkTextureUpload';
import {
  duplicateArrayRemove,
  getFilterLabelOptionId,
  getLocalStorage,
  inchesToCentimeter,
  objectRemoveUndefined,
  objectToFormData,
  openFormInCaseOfNewOrgAndFreemiumUser,
  removeExtension,
  removeLocalStorage,
  setLocalStorage,
  wait,
} from '../../helpers/jsHelper';
import { errorToast, successToast } from '../../helpers/toastHelper';
import { useDispatch, useSelector } from 'react-redux';

import { ADMIN_MY_PRODUCTS_TEXTURE } from '../../constants/routePathConstants';
import { AUTH_TOKEN } from '../../constants/projectConstants';
import ArrowDownIcon from '../icons/ArrowDownIcon';
import { BeforeUnload } from '../../common/BeforeUnload';
import { ElipsisTooltip } from '../../common/ElipsisTooltip';
import InfoDialogUI from '../InfoDialog/InfoDialogUI';
import { InfoIcon } from '../icons/InfoIcon';
import { ItemSelectListUI } from '../../common/OrgSection/ItemSelectListUI';
import { MY_PRODUCTS_ROUTE } from '../../constants/routePathConstants';
import MyDropzone from '../MyDropzone';
import { Stack } from 'react-bootstrap';
import { TEXTURE_BULK_DELETE } from '../../helpers/api';
import api from '../../helpers/axiosHelper';
import cx from 'classnames';
import { getFailedReason } from '../../helpers/urlHelper';
import icons from '../../assets';
import { saveAs } from 'file-saver';
import styles from './UploadBulkTextureModal.module.scss';
import { useInfoDialogaActions } from '../../hooks/useInfoDialogaActions';
import { useLocation } from 'react-router-dom';
import { useUserContext } from '../../contexts/UserContext';
import { useFilterList } from '../../hooks/useFilterList';
import { TYPE_TEXTURE } from '../../constants/textureConstants';

const { UploadXLXS, DownloadXLXS, File, ErrorIcon, CheckCircle, Timer, Uploading } = icons;

const EXCEL_MAIN_KEY = {
  SKU_ID: 'sku_id',
  IMAGE_NAME: 'image_name',
  DISPLAY_NAME: 'display_name',
  DESCRIPTION: 'description',
  HEIGHT_INCH: 'height(inch)',
  WIDTH_INCH: 'width(inch)',
  UPDATE: 'update',
};

const MODE = {
  EDIT: 'EDIT',
  UPLOAD: 'UPLOAD',
  DELETE: 'DELETE',
};

const TEXTURE_IDS_TO_REMOVE = 'TEXTURE_IDS';
export const TEXTURE_PROCESSING = 'TEXTURE_PROCESSING';

const API_ROOT_URL = process.env.REACT_APP_API_BASE_URL;
const makeAPICall = async (mode = MODE.UPLOAD, formData, errorMessage = null) => {
  let URL = '';
  if (mode === MODE.UPLOAD) {
    URL = TEXTURE_BULK_UPLOAD;
  } else if (mode === MODE.EDIT) {
    URL = TEXTURE_BULK_UPDATE;
  } else if (mode === MODE.DELETE) {
    URL = TEXTURE_BULK_DELETE;
  }
  try {
    return api()
      .root(API_ROOT_URL)
      .post(URL)
      .data(formData)
      .success((r) => r)
      .error((error) => {
        throw error;
      })
      .badRequest400((e) => {
        return e;
      })
      .accessDenied403((e) => {
        throw e;
      })
      .send();
  } catch (error) {
    throw error;
  }
};

const SetTextureIdsLocalStorage = (textureId) => {
  if (!textureId) return;
  let ids = JSON.parse(localStorage.getItem(TEXTURE_IDS_TO_REMOVE)) || [];
  if (ids.includes(textureId)) {
    ids = ids.filter((a) => a !== textureId);
  } else {
    ids = [...ids, textureId];
  }
  localStorage.setItem(TEXTURE_IDS_TO_REMOVE, JSON.stringify(duplicateArrayRemove(ids)));
  localStorage.setItem(TEXTURE_PROCESSING, JSON.stringify(true));
};

export const deleteUnuploadedTextures = () => {
  const ids = JSON.parse(localStorage.getItem(TEXTURE_IDS_TO_REMOVE)) || [];
  const isProcessing = JSON.parse(localStorage.getItem(TEXTURE_PROCESSING)) || false;
  if (ids?.length > 0 && !isProcessing) {
    ids?.map((id) => {
      if (id) {
        apiTrashForeverTextureDelete(id);
        SetTextureIdsLocalStorage(id);
      }
    });
  }
  if (ids?.length === 0) {
    removeLocalStorage(TEXTURE_IDS_TO_REMOVE);
    removeLocalStorage(TEXTURE_PROCESSING);
  }
};

const UploadBulkTextureModal = (props) => {
  const open = useSelector(selectIsBulkTextureModalOpen);
  if (!open) return null;

  return <UploadBulkTextureModalUI {...props} />;
};

const UploadBulkTextureModalUI = (props) => {
  const fileInputRef = useRef(null);
  const location = useLocation();
  const dispatch = useDispatch();
  const { filterList } = useFilterList({ type: TYPE_TEXTURE });
  const [xlsxError, setXlsxError] = useState('');
  const [checkError, setCheckError] = useState(false);
  const [xlsxList, setXlsxList] = useState([]);
  const [modelType, setModelType] = useState({
    isOpen: false,
  });
  const [xlsxDataArray, setXlsxDataArray] = useState(false);
  const [uploadedTextures, setUploadedTextures] = useState([]);
  const [loader, setLoader] = useState(false);
  const [beforeLoad, setBeforeLoad] = useState(true);

  const { currentUser } = useUserContext();
  const expand = useSelector(selectIsBulkTextureModalExpand);
  const { openInfoDialog, closeInfoDialog } = useInfoDialogaActions();
  const [isDialogOpened, setIsDialogOpened] = useState(false);

  const resetState = () => {
    setXlsxError('');
    setCheckError(false);
    setXlsxList([]);
    setModelType({ isOpen: false });
    setXlsxDataArray(false);
    setUploadedTextures([false]);
    setLoader(false);
    setBeforeLoad(true);
    dispatch(bulkTextureUploadActions.setExpand(true));
    dispatch(bulkTextureUploadActions.closeModal());
  };

  useEffect(() => {
    return () => {
      removeLocalStorage(TEXTURE_PROCESSING);
      deleteUnuploadedTextures();
      resetState();
    };
  }, [currentUser?.organization]);

  useEffect(() => {
    if (uploadedTextures?.length && !isDialogOpened) {
      const isLimitReached = uploadedTextures.some((texture) =>
        texture?.error?.includes('limit has been reached')
      );
      if (isLimitReached) {
        setIsDialogOpened(true);
        openFormInCaseOfNewOrgAndFreemiumUser({
          onCancelClick: () => {
            setIsDialogOpened(false);
          },
        });
      }
    }
  }, [uploadedTextures]);

  const routes = [MY_PRODUCTS_ROUTE, ADMIN_MY_PRODUCTS_TEXTURE];

  const allDelete = ['R', 'r'];
  const allUpdate = ['Y', 'y'];
  const notUpload = [...allUpdate, ...allDelete];

  function readExcelFile(file) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      fileReader.onload = (e) => {
        const bufferArray = e.target.result;
        const wb = XLSX.read(bufferArray, { type: 'buffer' });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws);
        const data1 = XLSX.utils.sheet_to_json(ws, { header: 1 });
        resolve([data1[0], ...data]);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  }

  useEffect(() => {
    if (fileInputRef.current) {
      const ele = document.getElementById('testll');
      ele.addEventListener('change', handleFileChange);
    }
  }, [fileInputRef.current]);

  const onUploadProgress = (e, skuId) => {
    setUploadedTextures((prev) =>
      prev.map((a) => {
        if (a?.skuId === skuId) {
          return {
            ...a,
            progress: Math.min(Math.floor((e.loaded / e.total) * 100), 100),
          };
        }
        return a;
      })
    );
  };

  const handleError = (data, isFiles, list) => {
    const newData = data.filter((item) => !Array.isArray(item));
    if (newData.length) {
      if (newData[0] === undefined) {
        return 'Empty XLSX file is not allowed';
      }

      const handleValidation = (data, value) => {
        return data.filter((item) => !item[value]);
      };

      const skuId = handleValidation(newData, EXCEL_MAIN_KEY.SKU_ID);
      const heightInch = handleValidation(newData, EXCEL_MAIN_KEY.HEIGHT_INCH);
      const widthInch = handleValidation(newData, EXCEL_MAIN_KEY.WIDTH_INCH);
      const imagName = handleValidation(newData, EXCEL_MAIN_KEY.IMAGE_NAME);
      const isUpdateList = imagName.filter((obj) => notUpload.includes(obj?.update || obj?.Update));

      if (
        skuId.length ||
        heightInch.length ||
        widthInch.length ||
        (imagName.length && !isUpdateList.length)
      ) {
        let errorMessage = '';
        if (skuId.length) errorMessage += 'SKU ID';
        if (heightInch.length) {
          if (skuId.length) errorMessage += ', ';
          errorMessage += 'Height';
        }
        if (widthInch.length) {
          if (skuId.length || heightInch.length) errorMessage += ', ';
          errorMessage += 'Width';
        }
        if (imagName.length && !isUpdateList.length) {
          if (skuId.length || heightInch.length || widthInch.length) errorMessage += ', ';
          errorMessage += 'Image name';
        }
        errorMessage += ' should not be empty';
        return errorMessage;
      }

      const filteredData = newData.filter((obj) => !obj.image_name);
      // const filteredData = updatedData.filter(obj => !obj.sku_id || !obj.image_name || !obj.display_name);
      const isUpdate = filteredData.filter((obj) => notUpload.includes(obj?.update || obj?.Update));
      if (filteredData.length && !isUpdate.length) {
        return 'Image name should not be empty';
        // return 'sku id, image name, Length(inch), Width(inch) should not be empty'
      } else {
        const res = isSkuIDUnique(newData);
        if (!res) {
          return 'SKU Id should be unique for every texture';
        }
        if (isFiles) {
          const deletableRemoved = newData.filter(
            (a) => !allDelete.includes(a?.update || a?.Update)
          );
          const filterOnlyUploadable = deletableRemoved
            .map((a) => {
              if (allUpdate.includes(a?.update || a?.Update) && !a?.[EXCEL_MAIN_KEY.IMAGE_NAME]) {
                return false;
              }
              return a;
            })
            .filter(Boolean);

          const allNames = filterOnlyUploadable.every((obj1) =>
            list.some((obj2) => obj1.image_name?.toLowerCase() === obj2?.name?.toLowerCase())
          );
          const missingSkuIds =
            list.length === 0
              ? filterOnlyUploadable.map((a) => a.sku_id)
              : filterOnlyUploadable
                  .map((obj1) => {
                    const exists = list.find(
                      (obj2) => obj1.image_name?.toLowerCase() === obj2?.name?.toLowerCase()
                    );
                    if (exists) {
                      return undefined;
                    }
                    return obj1?.sku_id;
                  })
                  .filter(Boolean);
          const missingImageName =
            list.length === 0
              ? filterOnlyUploadable.map((a) => a?.image_name)
              : filterOnlyUploadable
                  .map((obj1) => {
                    const exists = list.find(
                      (obj2) => obj1.image_name?.toLowerCase() === obj2?.name?.toLowerCase()
                    );
                    if (exists) {
                      return undefined;
                    }
                    return obj1?.image_name;
                  })
                  .filter(Boolean);

          if (!allNames) {
            return (
              <>
                Some of the files listed in the "Image name" column are not present in the selected
                folder.
                <br />
                <ShowMissingInfo
                  label={'More info'}
                  title={'Missing SKU Ids!!!'}
                  list={missingSkuIds}
                  missingImageName={missingImageName}
                  style={{ color: '#0059f1' }}
                />
              </>
            );
          }
        }
        return '';
      }
    } else if (data.length === 1) {
      return 'SKU Id, Image name, Width and Height should not be empty';
    } else return '';
  };

  const handleFileChange = async (files) => {
    const xlsxFiles = files.filter((file) => !ACCEPTABLE_IMAGE_TYPE.includes(file.type));
    setXlsxList(xlsxFiles);
    if (!xlsxFiles.length) {
      setXlsxError('XLSX or CSV File is Required.');
      return;
    }
    if (xlsxFiles && xlsxFiles.length > 1) {
      setXlsxError(
        'You can only upload one XLSX file at a time in order to accurately input the information on your files. Please reupload the files.'
      );
      return;
    }
    let ls = [];
    await readExcelFile(xlsxFiles[0])
      .then((data) => {
        const [excelHead, ...excelData] = data;

        const updatedHead = excelHead.map((a) => a.toLowerCase().replace(/ /g, '_'));
        const updatedData = excelData
          .map((obj) =>
            Object.keys(obj).reduce((newObj, key) => {
              const newKey = key.trim().toLowerCase().replace(/ /g, '_'); // Converting this for validation
              newObj[newKey] = obj[key]?.toString()?.trim();
              return newObj;
            }, {})
          )
          .reduce((acc, curr) => {
            if (!Object.values(curr).every((val) => val === '')) {
              acc.push(curr);
            }
            return acc;
          }, []);

        ls = [updatedHead, ...updatedData];
      })
      .catch((error) => {
        console.log(error);
      });

    const imgFiles = files.filter((file) => ACCEPTABLE_IMAGE_TYPE.includes(file.type));

    const error = handleError(ls, imgFiles.length > 0, imgFiles);
    if (error) {
      setXlsxError(error);
      return;
    }

    const filesError = handleError(ls, true, imgFiles);
    if (filesError) {
      setXlsxError(filesError);
      return;
    }
    setXlsxError('');
    setCheckError(true);
    setModelType({ ...modelType, isOpen: true });

    const XLXSKeys = ls
      .filter((a) => Array.isArray(a))?.[0]
      .map((a) => a.toLowerCase())
      .slice(0, -1);
    let newData = ls
      .filter((item) => !Array.isArray(item))
      .map((a) => {
        let object = {};
        Object.entries(a).map(([k, v]) => {
          object[k.toLowerCase()] = v;
        });

        XLXSKeys.forEach((key) => {
          if (!(key in object)) {
            object[key] = '';
          }
        });

        return object;
      });
    const uploadableData = newData.filter((a) => ![...allUpdate, ...allDelete].includes(a.update));
    const editableData = newData.filter((a) => 'update' in a && allUpdate.includes(a.update));
    const deletableData = newData.filter((a) => 'update' in a && allDelete.includes(a.update));

    newData = [...uploadableData, ...editableData, ...deletableData];
    if (newData.length) {
      setXlsxDataArray(newData);
      dispatch(bulkTextureUploadActions.setHasData(true));
      setUploadedTextures(
        newData.map((a) => ({
          id: a[EXCEL_MAIN_KEY.SKU_ID],
          name: a[EXCEL_MAIN_KEY.DISPLAY_NAME],
          skuId: a[EXCEL_MAIN_KEY.SKU_ID],
          imageName: a[EXCEL_MAIN_KEY.IMAGE_NAME],
          isUploaded: false,
          isUploading: false,
          progress: 0,
          error: '',
          isDeleted: false,
          status: 'In queue...',
          done: false,
        }))
      );
    }

    for (const item of newData) {
      const _sku_id = item[EXCEL_MAIN_KEY.SKU_ID].toString();
      const _image_name = item[EXCEL_MAIN_KEY.IMAGE_NAME];
      const _name = item[EXCEL_MAIN_KEY.DISPLAY_NAME];
      const _width = item[EXCEL_MAIN_KEY.WIDTH_INCH];
      const _height = item[EXCEL_MAIN_KEY.HEIGHT_INCH];
      const _texture_file_url_key = item[EXCEL_MAIN_KEY.IMAGE_NAME];
      const _description = item[EXCEL_MAIN_KEY.DESCRIPTION] || '';

      let itemClone = { ...item };
      const _filter_data = [];
      Object.values(EXCEL_MAIN_KEY).forEach((i) => {
        delete itemClone[i];
      });
      if (Object.keys(itemClone).length) {
        Object.keys(itemClone).forEach((item) => {
          _filter_data.push({ label: item, options: itemClone[item].toString() });
        });
      }

      let payload = {
        sku_id: _sku_id,
        name: _name,
        width: inchesToCentimeter(_width),
        height: inchesToCentimeter(_height),
        description: _description,
        is_map: false,
        texture_file_url_key: _texture_file_url_key,
        rotation: 0,
        filter_data: JSON.stringify(_filter_data),
      };

      const isItemForDelete = 'update' in item && allDelete.includes(item.update);
      const isItemForEdit = 'update' in item && allUpdate.includes(item.update);

      if (isItemForDelete) {
        const formData = new FormData();
        const texture = await apiGetTextures(`sku_id=${item[EXCEL_MAIN_KEY.SKU_ID]}`);
        const textureId = texture?.results?.[0]?.id;
        if (textureId) {
          formData.append('id', textureId);
          await makeAPICall(MODE.DELETE, formData)
            .then((response) => {
              setUploadedTextures((prev) =>
                prev.map((a) => {
                  if (a?.skuId.toLowerCase() === _sku_id?.toLowerCase()) {
                    return {
                      ...a,
                      id: _sku_id,
                      isDeleted: true,
                      status: 'Deleted',
                      done: true,
                    };
                  }
                  return a;
                })
              );
            })
            .catch((error) => {
              const reasonId = error.data?.[textureId]?.reason;
              const projectData =
                error?.data?.[textureId]?.reason_data?.project_data?.[0] ||
                error?.data?.[textureId]?.reason_data;
              let reason =
                reasonId === 1
                  ? 'You can not delete this file due to ownership rights'
                  : getFailedReason(reasonId);
              setUploadedTextures((prev) =>
                prev.map((a) => {
                  if (a?.skuId.toLowerCase() === _sku_id?.toLowerCase()) {
                    if (+reasonId === 5 && projectData) {
                      reason = `The texture is used in "${projectData?.automation_name_id}" Automation, Automation template name is "${projectData?.automation_template_name_id}" and SKU ID is "${a?.skuId}"`;
                    }
                    if (+reasonId === 2 && projectData) {
                      reason = `The texture is used in "${projectData?.name}" project, and SKU ID is "${a?.skuId}"`;
                    }
                    return {
                      ...a,
                      id: _sku_id,
                      isDeleted: false,
                      status: '',
                      error: reason || error?.message || 'Something went wrong!',
                      done: true,
                    };
                  }
                  return a;
                })
              );
            });
        } else {
          setUploadedTextures((prev) =>
            prev.map((a) => {
              if (a?.skuId.toLowerCase() === _sku_id?.toLowerCase()) {
                return {
                  ...a,
                  id: _sku_id,
                  isDeleted: false,
                  status: '',
                  error: `SKU Id not found - "${_sku_id}"`,
                  done: true,
                };
              }
              return a;
            })
          );
        }
      } else if (isItemForEdit) {
        const texture = await apiGetTextures(`sku_id=${_sku_id}`);
        if (texture?.results?.length === 0) {
          setUploadedTextures((prev) =>
            prev.map((a) => {
              if (a?.skuId.toLowerCase() === _sku_id?.toLowerCase()) {
                return {
                  ...a,
                  status: '',
                  error: `SKU Id not found - "${_sku_id}"`,
                  done: true,
                };
              }
              return a;
            })
          );
        } else {
          const textureId = texture?.results?.[0]?.id;
          let presigned_data = null;
          if (_image_name) {
            const presignedData = await apiGetImagePresignedData([textureId]);
            if (presignedData?.results?.length === 0) {
              setUploadedTextures((prev) =>
                prev.map((a) => {
                  if (a?.skuId.toLowerCase() === _sku_id?.toLowerCase()) {
                    return {
                      ...a,
                      status: '',
                      error: 'No presigned data found',
                      done: true,
                    };
                  }
                  return a;
                })
              );
              return;
            }
            const res = presignedData?.results?.[0];
            presigned_data = res?.presigned_data;
            payload['texture_file_url_key'] = presigned_data?.fields.key;
          }

          const file = imgFiles.find(
            (file) => file?.name?.toLowerCase() === _image_name?.toLowerCase()
          );

          if (_image_name && presigned_data && file) {
            setUploadedTextures((prev) =>
              prev.map((a) => {
                if (a?.skuId.toLowerCase() === _sku_id?.toLowerCase()) {
                  return {
                    ...a,
                    id: _sku_id,
                    isUploading: true,
                    status: 'Uploading...',
                    done: false,
                  };
                }
                return a;
              })
            );

            await uploadImage(textureId, _sku_id, file, presigned_data, true);
          } else {
            setUploadedTextures((prev) =>
              prev.map((a) => {
                if (a?.skuId?.toLowerCase() === _sku_id?.toLowerCase()) {
                  return {
                    ...a,
                    id: _sku_id,
                    isUploading: true,
                    isUploaded: false,
                    status: 'Updating...',
                    done: false,
                  };
                }
                return a;
              })
            );
          }

          payload['id'] = textureId;
          payload = objectRemoveUndefined(payload);
          const formData = objectToFormData(payload);
          await makeAPICall(MODE.EDIT, formData)
            .then(async (response) => {
              if (response && response.status) {
                setUploadedTextures((prev) =>
                  prev.map((a) => {
                    if (a?.skuId?.toLowerCase() === _sku_id?.toLowerCase()) {
                      return {
                        ...a,
                        id: _sku_id,
                        isUploading: false,
                        isUploaded: true,
                        status: 'Updated',
                        done: true,
                      };
                    }
                    return a;
                  })
                );
              }
            })
            .catch((error) => {
              setUploadedTextures((prev) =>
                prev.map((a) => {
                  if (a?.skuId?.toLowerCase() === _sku_id?.toLowerCase()) {
                    return {
                      ...a,
                      isUploading: false,
                      error: error?.message,
                      done: true,
                    };
                  }
                  return a;
                })
              );
            });
        }
      } else {
        // if display name is not available, then we are sending image name or sku_id
        if (!payload.name) {
          payload.name = removeExtension(_image_name) || _sku_id;
        }
        payload = objectRemoveUndefined(payload);
        const textureUploadFilterOptionType = getFilterLabelOptionId(
          filterList,
          TEXTURE_FILTER_LABEL,
          TEXTURE_UPLOADS_FROM_TYPES.MY_TEXTURE
        );
        if (textureUploadFilterOptionType) {
          if (payload?.filteroptions) {
            payload.filteroptions.push(textureUploadFilterOptionType);
          } else {
            payload['filteroptions'] = [textureUploadFilterOptionType];
          }
        }
        const formData = objectToFormData(payload);
        await makeAPICall(MODE.UPLOAD, formData)
          .then(async (response) => {
            if (response && response.status) {
              const { id, name, presigned_data } = response?.data?.[0];

              const file = imgFiles.find(
                (file) => file?.name?.toLowerCase() === _image_name?.toLowerCase()
              );

              let isDone = true;
              if (_image_name && file) {
                isDone = false;
              }

              setUploadedTextures((prev) =>
                prev.map((a) => {
                  if (a?.skuId?.toLowerCase() === _sku_id?.toLowerCase()) {
                    return {
                      ...a,
                      id: _sku_id,
                      isUploading: true,
                      status: 'Uploading...',
                      done: isDone,
                    };
                  }
                  return a;
                })
              );

              if (_image_name && file) {
                SetTextureIdsLocalStorage(id);

                await uploadImage(id, _sku_id, file, presigned_data);
              } else {
                setUploadedTextures((prev) =>
                  prev.map((a) => {
                    if (a?.skuId?.toLowerCase() === _sku_id?.toLowerCase()) {
                      return {
                        ...a,
                        id: _sku_id,
                        isUploading: false,
                        status: 'Updated',
                        done: true,
                      };
                    }
                    return a;
                  })
                );
              }
            }
          })
          .catch((error) => {
            setUploadedTextures((prev) =>
              prev.map((a) => {
                if (a?.skuId?.toLowerCase() === _sku_id?.toLowerCase()) {
                  return {
                    ...a,
                    isUploading: false,
                    error: error?.message,
                    done: true,
                  };
                }
                return a;
              })
            );
          });
      }
    }
  };

  async function uploadImage(id, _sku_id, file, presigned_data, isTextureUpdating = false) {
    if (!_sku_id || !file || !presigned_data) return;

    const response = await apiPostImageOnPresignedData(file, presigned_data, (e) =>
      onUploadProgress(e, _sku_id)
    );

    if (response.status === 204) {
      const res = {
        id: _sku_id,
        status: response.status || false,
      };

      if (!isTextureUpdating) {
        setUploadedTextures((prev) =>
          prev.map((a) => {
            if (a?.skuId?.toLowerCase() === _sku_id?.toLowerCase()) {
              return {
                ...a,
                id: _sku_id,
                isUploading: false,
                isUploaded: true,
                status: 'Uploaded to Textures',
                done: true,
              };
            }
            return a;
          })
        );

        SetTextureIdsLocalStorage(id);
      }
    } else {
      if (id && !isTextureUpdating) {
        await apiTrashForeverTextureDelete(id);
        SetTextureIdsLocalStorage(id);
      }
      console.log('apiPostImageOnPresignedData failed: ', response);
    }
  }

  function isSkuIDUnique(data) {
    const names = data.map((obj) => obj.sku_id);
    const uniqueNames = new Set(names);
    return names.length === uniqueNames.size;
  }

  const downloadXLSX = async () => {
    const token = getLocalStorage(AUTH_TOKEN);
    if (!token) {
      errorToast('Token not found.');
      return;
    }
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': SHEET_FILE_TYPE, Authorization: `Bearer ${token}` },
    };
    setLoader(true);

    fetch(`${process.env.REACT_APP_API_BASE_URL}${DOWNLOAD_XLSX_TEXTURE}`, requestOptions)
      .then((response) => {
        if (response?.ok) {
          return response.blob();
        } else {
          errorToast('Something went wrong');
        }
      })
      .then((blob) => {
        setLoader(false);
        saveAs(blob, 'sampleXLSXTexture.xlsx');
      })
      .catch((error) => errorToast(error?.message || 'Something went wrong'));
  };

  // useEffect(() => {
  //   if (isModalOpen && !modelType?.isOpen) {
  //     document.body.classList.add('modal-backdrop-open');
  //   } else {
  //     document.body.classList.remove('modal-backdrop-open');
  //   }
  // }, [isModalOpen, modelType?.isOpen]);

  useEffect(() => {
    if (modelType?.isOpen) {
      document.body.classList.add('overflow-auto');
    }
  }, [modelType?.isOpen]);

  const showTextureListModal = uploadedTextures.length > 0;

  const noOfUploadCompletes = useMemo(() => {
    return uploadedTextures.filter((a) => a.done).length;
  }, [uploadedTextures]);

  const isTextureUploadingContinue = useMemo(() => {
    return uploadedTextures.some((a) => a.isUploading);
  }, [uploadedTextures]);

  const isTextureUploadCompletes = useMemo(() => {
    const isAllDone = uploadedTextures.length > 0 && uploadedTextures.every((a) => a.done);
    dispatch(bulkTextureUploadActions.setProcessing(!isAllDone));
    return isAllDone;
  }, [uploadedTextures]);

  useEffect(() => {
    if (isTextureUploadCompletes) {
      successToast('Texture processing completed successfully.');
    }
  }, [isTextureUploadCompletes]);

  const handleTextureConfirmModal = () => {
    openInfoDialog({
      title: 'Attention!!!',
      description: 'If you proceed, you may lose some data.',
      buttonText: 'Proceed',
      cancelButtonText: 'Cancel',
      onClose: () => setBeforeLoad(true),
      onCancelClick: () => {
        setBeforeLoad(true);
        closeInfoDialog();
      },
      onButtonClick: handleConfirm,
    });
    return;
  };

  const handleConfirm = async () => {
    removeLocalStorage(TEXTURE_PROCESSING);
    deleteUnuploadedTextures();
    await wait(1000);
    dispatch(bulkTextureUploadActions.closeModal());
    document.body.classList.remove('modal-backdrop-open');
    if (routes.includes(location.pathname)) {
      window.location.reload();
    }
  };

  const handleCloseModal = () => {
    if (uploadedTextures.length > 0 && (isTextureUploadingContinue || !isTextureUploadCompletes)) {
      setBeforeLoad(false);
      handleTextureConfirmModal();
    } else {
      setBeforeLoad(true);
      dispatch(bulkTextureUploadActions.closeModal());
      document.body.classList.remove('modal-backdrop-open');
      document.body.classList.remove('overflow-auto');
    }
  };

  const preventClose = () => {
    if (!isTextureUploadCompletes) {
      removeLocalStorage(TEXTURE_PROCESSING);
      deleteUnuploadedTextures();
      return 'Are you sure you want to exit? All unsaved changes will be lost!';
    }
  };

  return (
    <>
      {beforeLoad && showTextureListModal && <BeforeUnload onBeforeunload={preventClose} />}
      <ModalButtonArea
        {...props}
        size="md"
        centered={true}
        bigButton={false}
        // bigButton={true}
        variant="link"
        buttonTitle={props.buttonTitle}
        iconBefore={props.iconBefore}
        isCloseModal={true}
        onCloseModal={handleCloseModal}
        checkForPermission="UPLOAD_TEXTURE"
        className="upload-texture-modal"
        parentClassName={`${modelType?.isOpen ? styles.textureMinimize : ''} ${styles.modal}`}
        disabled={props.disableButton}
        headingLeft
        showModal={true}
        backdropClassName={`overlay-dark ${modelType?.isOpen ? styles.textureOpen : ''}`}
        bodyClassName={cx(
          showTextureListModal ? styles.collapse : '',
          !expand ? styles.collapsed : ''
        )}
        contentClassName={modelType?.isOpen ? styles.textureSideModal : ''}
        enforceFocus={false}
        title={
          <div className={showTextureListModal ? styles.header : ''}>
            <h4>
              {!modelType?.isOpen
                ? 'Upload textures with XLSX'
                : `${noOfUploadCompletes} of ${xlsxDataArray ? xlsxDataArray.length : 0} complete`}
            </h4>
            {showTextureListModal && (
              <button
                onClick={() => dispatch(bulkTextureUploadActions.setExpand(!expand))}
                className={cx(styles.iconButton, {
                  [styles.expandOpen]: !expand,
                })}>
                <ArrowDownIcon />
              </button>
            )}
          </div>
        }
        body={
          <>
            {!modelType?.isOpen ? (
              <>
                <MyDropzone
                  v2UploadTextures
                  subTitle="(.xlsx, .csv (use ';' as delimiter), .jpg, .png files supported. Max resolution 16k)"
                  onDrop={handleFileChange}
                  isXlsx
                  ref={fileInputRef}
                />
                <div className="sample-download mt-3" onClick={downloadXLSX}>
                  <DownloadXLXS />
                  Download sample .xlsx file
                </div>
              </>
            ) : (
              ''
            )}
            {loader ? <Loader loading /> : null}
            {xlsxList.length || xlsxError ? (
              <Stack>
                <div
                  style={{
                    margin: ' 0 0 1rem',
                    overflowX: 'hidden',
                    overflowY: 'auto',
                  }}>
                  <ul className={cx(styles.list)}>
                    {xlsxList.map((xlxs, index) => {
                      const { name } = xlxs;
                      let icon = null;
                      if (!xlsxError && checkError) {
                        icon = CheckCircle;
                      } else {
                        icon = UploadXLXS;
                      }

                      return <RowCard key={index} title={name} icon={icon} />;
                    })}

                    {/* showing EXCEL length error */}
                    {xlsxError ? (
                      <RowCard icon={ErrorIcon} title={xlsxError} showError={true} />
                    ) : null}
                  </ul>
                </div>
                {showTextureListModal ? (
                  <div
                    style={{
                      overflowX: 'hidden',
                      overflowY: 'auto',
                      marginTop: '0.5rem',
                    }}>
                    <ul className={cx(styles.list)}>
                      {uploadedTextures.map((file, index) => {
                        const {
                          name,
                          skuId,
                          imageName,
                          isUploaded,
                          isUploading,
                          progress,
                          error,
                          isDeleted,
                          status,
                        } = file;

                        let icon = Timer;
                        let animate = false;
                        if (isUploading) {
                          icon = Uploading;
                          animate = true;
                        } else if (isUploaded || isDeleted) {
                          icon = CheckCircle;
                        } else if (!isUploading) {
                          icon = Timer;
                        }
                        if (error) {
                          icon = ErrorIcon;
                        }

                        return (
                          <RowCard
                            key={index}
                            title={name || removeExtension(imageName) || skuId}
                            icon={icon}
                            description={error || status}
                            animate={animate}
                            showProgressBar={isUploading}
                            showError={error !== ''}
                            progress={progress}
                          />
                        );
                      })}
                    </ul>
                  </div>
                ) : (
                  ''
                )}
              </Stack>
            ) : (
              ''
            )}
          </>
        }
      />
    </>
  );
};

export default UploadBulkTextureModal;

const RowCard = ({
  title = '',
  icon = null,
  description = '',
  showError = false,
  showProgressBar = false,
  progress = 0,
  animate = false,
}) => {
  const Icon = icon;
  if (!title) return null;
  return (
    <li>
      <div className={cx(styles.item, showError ? styles.error : '')}>
        <div className="d-flex" style={{ gap: '12px' }}>
          {Icon && (
            <Icon
              style={{ width: '24px', height: '24px', flex: '0 0 24px' }}
              className={cx('file-icon', animate ? styles.animate : '')}
            />
          )}
          <div className={styles.info}>
            <ElipsisTooltip title={title}>
              {(props) => (
                <h2 className={styles.title} {...props}>
                  {title}
                </h2>
              )}
            </ElipsisTooltip>
            {description && <p className={styles.description}>{description}</p>}
          </div>
        </div>
        {showProgressBar && (
          <BulkTextureUploadProgress
            id={title}
            _progress={progress}
            className="upload-progress mt-2"
            height="6"
          />
        )}
      </div>
    </li>
  );
};

const ShowMissingInfo = ({
  label = '',
  title = 'Missing details!!!',
  list = [],
  missingImageName = [],
  style = {},
}) => {
  const [show, setShow] = useState(false);
  const formattedList = useMemo(() => {
    return list.map((a, i) => {
      return {
        id: i + 1,
        title: a,
      };
    });
  }, [list]);

  if (list.length === 0) return null;
  return (
    <>
      <div className="d-inline-block pt-1 pb-1">
        <span>{label}</span>
        <InfoIcon
          style={{ cursor: 'pointer', width: 24, height: 24, ...style }}
          onClick={() => setShow(true)}
        />
      </div>
      <InfoDialogUI
        show={show}
        title={title}
        onClose={() => setShow(false)}
        dialogClassName="missing-sku-id-dialog">
        <ItemSelectListUI
          items={formattedList}
          missingImageName={missingImageName}
          selected={null}
          onChange={null}
          loading={false}
          hasData={true}
          hasMore={false}
        />
      </InfoDialogUI>
    </>
  );
};
